var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsterix3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 375,
    viewBox: "0 0 190 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.672 205.5L60.1719 199L182.672 242.5L168.672 276L52.1719 220.5L147.672 307L122.172 333L35.1719 236.5L90.6719 353.5L57.1719 367.5L14.1719 246.5L20.6719 375H-15.8281L-9.32812 246L-52.3281 367.5L-86.3281 354L-30.8281 237.5L-117.328 333L-142.828 307L-47.3281 220.5L-163.828 276L-177.328 242.5L-55.3281 199L-185.328 205.5V169.5L-55.3281 176L-177.828 132.5L-163.828 99L-46.8281 154.5L-142.828 67.5L-117.328 42L-30.8281 137.5L-86.3281 21L-52.8281 6.99998L-9.32812 129.5L-15.8281 -1.66893e-05H20.6719L14.1719 128.5L57.1719 7.49998L90.6719 21.5L35.1719 138.5L122.172 42L147.672 68L52.1719 154.5L168.672 99L182.672 132.5L60.1719 176L189.672 169.5V205.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterix3);
export default __webpack_public_path__ + "static/media/asterix3.a3bc0fa83d7f6cfc99a8b79306e83789.svg";
export { ForwardRef as ReactComponent };